
<div class="modal-holder">
    <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" class="close modalClose" aria-label="Close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>{{ message }}</p>
        <hr>
        <div class="btn-group">
            <button type="button" class="ct-btn secondary-btn mr-2" ngbAutofocus
                (click)="activeModal.close()">Cancel</button>
            <button type="button" class="ct-btn primary-btn left-margin" (click)="activeModal.close('Delete')">Yes</button>
        </div>
    </div>
</div>